import { useEffect } from "react";

const setMeta = (attr, key, content) => {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setLink = (rel, href) => {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

// Balises SEO par page : title, description, canonical, Open Graph et Twitter
// sont recalculés à chaque navigation (l'URL absolue suit automatiquement le
// domaine public, de prévisualisation ou de production).
const Seo = ({ title, description, jsonLd, breadcrumbs }) => {
  useEffect(() => {
    const origin = window.location.origin;
    const url = origin + window.location.pathname;
    if (title) {
      document.title = title;
      setMeta("property", "og:title", title);
      setMeta("name", "twitter:title", title);
    }
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }
    setLink("canonical", url);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", `${origin}/og-image.png`);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:image", `${origin}/og-image.png`);
  }, [title, description]);

  const jsonKey = JSON.stringify(jsonLd || null);
  const bcKey = JSON.stringify(breadcrumbs || null);

  useEffect(() => {
    const scripts = [];
    const add = (data) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-seo-jsonld", "true");
      s.text = JSON.stringify(data);
      document.head.appendChild(s);
      scripts.push(s);
    };
    if (jsonLd) add(jsonLd);
    if (breadcrumbs && breadcrumbs.length > 0) {
      const origin = window.location.origin;
      add({
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: breadcrumbs.map((b, i) => ({
          "@type": "ListItem",
          position: i + 1,
          name: b.label,
          ...(b.to ? { item: origin + b.to } : {}),
        })),
      });
    }
    return () => scripts.forEach((s) => s.remove());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jsonKey, bcKey]);

  return null;
};

export default Seo;
